import LiveIcon from "../pages/sidebar/img/LiveIcon.svg";

import AssetsIcon from "../pages/sidebar/img/AssetsIcon.svg";

import ScheduleManagementIcon from "../pages/sidebar/img/ScheduleManagementIcon.svg";

import UsersIcon from "../pages/sidebar/img/UsersIcon.svg";

import NotificationsIcon from "../pages/sidebar/img/NotificationsIcon.svg";

import SchedulingIcon from "../pages/sidebar/img/SchedulingIcon.svg";

import AuditIcon from "../pages/sidebar/img/Audit.svg";

import CMSIcon from "../pages/sidebar/img/CMS.svg";

import { dashboardPath, DASHBOARD_PATHS as P } from "./dashboardRoutes.js";



/** Primary sidebar navigation items for the institution dashboard. */

export const SIDEBAR_NAV_ITEMS = [

  {

    name: "Live",

    primaryPath: dashboardPath(P.mapOverview),

    alternatePaths: [dashboardPath(P.dispatchBoard)],

    icon: LiveIcon,

    moduleKeys: ["mapOverview", "dispatchBoard"],

  },

  {

    name: "Scheduling",

    primaryPath: dashboardPath(P.scheduling),

    icon: SchedulingIcon,

    moduleKeys: ["scheduling"],

  },

  {

    name: "Fleet Management",

    primaryPath: dashboardPath(P.vehicles),

    alternatePaths: [dashboardPath(P.drivers)],

    icon: AssetsIcon,

    moduleKeys: ["vehicles", "drivers"],

  },

  {

    name: "Route Management",

    primaryPath: dashboardPath(P.trips),

    alternatePaths: [dashboardPath(P.stops)],

    icon: ScheduleManagementIcon,

    moduleKeys: ["routeManagement"],

  },

  {

    name: "Manage Users",

    primaryPath: dashboardPath(P.administrators),

    alternatePaths: [dashboardPath(P.familyManagement)],

    icon: UsersIcon,

    moduleKeys: ["administrators", "familyManagement"],

  },

  {

    name: "Notifications Campaign",

    primaryPath: dashboardPath(P.notifications),

    icon: NotificationsIcon,

    moduleKeys: ["campaignManagement"],

  },

  {

    name: "Audit Logs",

    primaryPath: dashboardPath(P.auditLogs),

    icon: AuditIcon,

    moduleKeys: ["auditLogs"],

    allowedRoles: ["SUPERADMIN", "ADMIN", "EDITOR"],

  },

  {

    name: "Content Management",

    primaryPath: dashboardPath(P.serviceAnnouncement),

    icon: CMSIcon,

    moduleKeys: ["serviceAnnouncement", "busPolicy", "generalPolicy"],

    allowedRoles: ["SUPERADMIN", "ADMIN", "EDITOR"],

  },

];



/** Sub-navigation tabs shown in NavBar, keyed by page `type` prop. */

export const NAV_BAR_SUB_NAV = {

  mapOverview: [

    { text: "Map Overview", path: dashboardPath(P.mapOverview), key: "mapOverview" },

    { text: "Dispatch Board", path: dashboardPath(P.dispatchBoard), key: "dispatchBoard" },

  ],

  dispatchBoard: [

    { text: "Map Overview", path: dashboardPath(P.mapOverview), key: "mapOverview" },

    { text: "Dispatch Board", path: dashboardPath(P.dispatchBoard), key: "dispatchBoard" },

  ],

  vehicles: [

    { text: "Vehicles", path: dashboardPath(P.vehicles), key: "vehicles" },

    { text: "Drivers", path: dashboardPath(P.drivers), key: "drivers" },

  ],

  drivers: [

    { text: "Vehicles", path: dashboardPath(P.vehicles), key: "vehicles" },

    { text: "Drivers", path: dashboardPath(P.drivers), key: "drivers" },

  ],

  trips: [

    { text: "Trips", path: dashboardPath(P.trips), key: "routeManagement" },

    { text: "Stops", path: dashboardPath(P.stops), key: "routeManagement" },

  ],

  stops: [

    { text: "Trips", path: dashboardPath(P.trips), key: "routeManagement" },

    { text: "Stops", path: dashboardPath(P.stops), key: "routeManagement" },

  ],

  adminUser: [

    { text: "Administrators", path: dashboardPath(P.administrators), key: "administrators" },

    { text: "Family Management", path: dashboardPath(P.familyManagement), key: "familyManagement" },

  ],

  notifications: [

    { text: "Notifications Campaign", path: dashboardPath(P.notifications), key: "campaignManagement" },

  ],

  familyManagement: [

    { text: "Administrators", path: dashboardPath(P.administrators), key: "administrators" },

    { text: "Family Management", path: dashboardPath(P.familyManagement), key: "familyManagement" },

  ],

  scheduling: [

    { text: "Scheduling", path: dashboardPath(P.scheduling), key: "scheduling" },

    { text: "Student Schedules", path: dashboardPath(P.studentSchedules), key: "scheduling" },

  ],

  studentSchedules: [

    { text: "Scheduling", path: dashboardPath(P.scheduling), key: "scheduling" },

    { text: "Student Schedules", path: dashboardPath(P.studentSchedules), key: "scheduling" },

  ],

  audit: [

    { text: "Audit Logs", path: dashboardPath(P.auditLogs), key: "auditLogs" },

  ],

  serviceAnnouncement: [

    { text: "Service Announcement", path: dashboardPath(P.serviceAnnouncement), key: "serviceAnnouncement" },

    { text: "Bus Policy", path: dashboardPath(P.busPolicy), key: "busPolicy" },

    { text: "General Policy", path: dashboardPath(P.generalPolicy), key: "generalPolicy" },

  ],

  busPolicy: [

    { text: "Service Announcement", path: dashboardPath(P.serviceAnnouncement), key: "serviceAnnouncement" },

    { text: "Bus Policy", path: dashboardPath(P.busPolicy), key: "busPolicy" },

    { text: "General Policy", path: dashboardPath(P.generalPolicy), key: "generalPolicy" },

  ],

  generalPolicy: [

    { text: "Service Announcement", path: dashboardPath(P.serviceAnnouncement), key: "serviceAnnouncement" },

    { text: "Bus Policy", path: dashboardPath(P.busPolicy), key: "busPolicy" },

    { text: "General Policy", path: dashboardPath(P.generalPolicy), key: "generalPolicy" },

  ],

  externalApps: [

    { text: "External Apps", path: dashboardPath(P.externalApps) },

  ],

};



/** Back-button labels in NavBar form views, keyed by page `type` prop. */

export const NAV_BAR_BACK_LABELS = {

  adminUser: "Admin Users",

  notifications: "Notifications Campaign",

  stops: "Stops",

  trips: "Trips",

  familyManagement: "Family Management",

  vehicles: "Vehicles",

  drivers: "Drivers",

  scheduling: "Scheduling",

  studentSchedules: "Student Schedules",

  audit: "Audit Logs",

  serviceAnnouncement: "Service Announcement",

  busPolicy: "Bus Policy",

  generalPolicy: "General Policy",

};



/** Roles allowed for CMS and audit sub-nav items without module checks. */

export const CMS_AUDIT_ROLES = ["SUPERADMIN", "ADMIN", "EDITOR"];


